import {
  insiderTradingsHasActivity,
  politicianTransactionsHasActivity,
} from './insiderCongressUtils.js';

export function shouldShowInsiderCard(_hasMounted, insiderLoading, insiderTradings) {
  return insiderLoading || insiderTradingsHasActivity(insiderTradings);
}

export function shouldShowCongressCard(_hasMounted, congressLoading, politicianTransactions) {
  return congressLoading || politicianTransactionsHasActivity(politicianTransactions);
}
